import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import {
  MinimalUserInfo,
  THistory,
  THistoryDisplayItem,
  THistoryDocumentChangeGroup,
} from "../../../models";
import { ICompanyVerificationStatusesConfig } from "../../../network";

export type HistoryItemProps = {
  item: THistory;
  statusesConfig: ICompanyVerificationStatusesConfig;
};

export type HistoryDisplayItemProps = {
  item: THistoryDisplayItem;
  statusesConfig: ICompanyVerificationStatusesConfig;
  verificationRequestId: string;
};

export type HistoryDocumentChangeGroupProps = {
  item: THistoryDocumentChangeGroup;
  statusesConfig: ICompanyVerificationStatusesConfig;
  verificationRequestId: string;
};

type UserInfoDisplayProps = {
  item: {
    userInfo?: MinimalUserInfo;
  };
  statusesConfig: ICompanyVerificationStatusesConfig;
};

export const DateGrid = styled(Grid)`
  color: grey;
  opacity: 0.7;
`;

export const HistoryGrid = styled(Grid)`
  margin-left: 8px;
  padding-left: 20px;
  position: relative;
  &:not(:last-child) {
    /* background-color: red; */
    padding-bottom: 20px;

    border-left: 1px solid #dee0e4;
  }
`;

export const HistoryEntryIcon = styled(Box)`
  height: 24px;
  left: -11px;
  position: absolute;
  background-color: white;
  & svg {
    vertical-align: middle;
  }
`;

export const HistoryEntryMainText = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
`;

const HistoryEntrySubTextComponent = styled(Grid)`
  font-size: 14px;
  color: grey;
  opacity: 0.7;
  display: inline-block;
`;

export const HistoryEntrySubText = function ({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <HistoryEntrySubTextComponent container item>
      <strong>{label}:</strong> {children}
    </HistoryEntrySubTextComponent>
  );
};

const UserInfoDisplayComponent = styled(Grid)`
  font-size: 14px;
  color: grey;
  opacity: 0.7;
  display: inline-block;
  font-weight: 700;
`;

export const UserInfoDisplay = function ({ item }: UserInfoDisplayProps) {
  if (!item.userInfo?.display) {
    return null;
  }

  return (
    <UserInfoDisplayComponent container item>
      by {item.userInfo.display}
    </UserInfoDisplayComponent>
  );
};
